import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const FacebookPage = async () => import('@/pages/FacebookPage.vue');
const FacebookAccountFormModal = async () =>
  import('@/features/facebook/facebook-account-form-modal/FacebookAccountFormModal.vue');
const FacebookProxiesListModal = async () =>
  import('@/features/facebook/proxies/proxies-list-modal/FacebookProxiesListModal.vue');
const FacebookProxyFormModal = async () =>
  import('@/features/facebook/proxies/proxy-form-modal/FacebookProxyFormModal.vue');
const FacebookCapiTokensListModal = async () =>
  import('@/features/facebook/capi-tokens/capi-tokens-list-modal/FacebookCapiTokensListModal.vue');
const FacebookCapiTokenFormModal = async () =>
  import('@/features/facebook/capi-tokens/capi-token-form-modal/FacebookCapiTokenFormModal.vue');
const FacebookPixelsListModal = async () =>
  import('@/features/facebook/pixels/pixels-list-modal/FacebookPixelsListModal.vue');
const FacebookPixelFormModal = async () =>
  import('@/features/facebook/pixels/pixel-form-modal/FacebookPixelFormModal.vue');
const FacebookEventLayoutsListModal = async () =>
  import('@/features/facebook/event-layouts/event-layouts-list-modal/FacebookEventLayoutsListModal.vue');
const FacebookEventLayoutFormModal = async () =>
  import('@/features/facebook/event-layouts/event-layout-form-modal/FacebookEventLayoutFormModal.vue');

const FacebookCapiJournalModal = async () =>
  import('@/features/facebook/capi-journal/capi-journal-modal/FacebookCapiJournalModal.vue');

type FormModalPageProps = {
  action: CrudAction;
};

export function getFacebookRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'facebook',
      children: [
        {
          name: 'create-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/create',
          props: (): FormModalPageProps => ({
            action: {
              type: CrudActionType.CREATE,
            },
          }),
        },
        {
          name: 'edit-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/edit/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.EDIT,
            },
          }),
        },
        {
          name: 'clone-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/clone/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.CLONE,
            },
          }),
        },
        {
          name: 'facebook-proxies',
          children: [
            {
              name: 'create-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              name: 'edit-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
            {
              name: 'clone-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/clone/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.CLONE,
                },
              }),
            },
          ],
          component: FacebookProxiesListModal,
          path: '/facebook/proxies',
        },
        {
          name: 'facebook-capi-tokens',
          children: [
            {
              name: 'create-facebook-capi-token',
              component: FacebookCapiTokenFormModal,
              path: '/facebook/capi-tokens/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              name: 'edit-facebook-capi-token',
              component: FacebookCapiTokenFormModal,
              path: '/facebook/capi-tokens/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
          ],
          component: FacebookCapiTokensListModal,
          path: '/facebook/capi-tokens',
        },
        {
          name: 'facebook-pixels',
          children: [
            {
              name: 'create-facebook-pixel',
              component: FacebookPixelFormModal,
              path: '/facebook/pixels/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              name: 'edit-facebook-pixel',
              component: FacebookPixelFormModal,
              path: '/facebook/pixels/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
          ],
          component: FacebookPixelsListModal,
          path: '/facebook/pixels',
        },
        {
          name: 'facebook-event-layouts',
          children: [
            {
              name: 'create-facebook-event-layout',
              component: FacebookEventLayoutFormModal,
              path: '/facebook/events-mapping/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              name: 'edit-facebook-event-layout',
              component: FacebookEventLayoutFormModal,
              path: '/facebook/events-mapping/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
          ],
          component: FacebookEventLayoutsListModal,
          path: '/facebook/events-mapping',
        },
        {
          name: 'facebook-capi-journal',
          component: FacebookCapiJournalModal,
          path: '/facebook/capi-log',
        },
      ],
      component: FacebookPage,
      meta: {
        title: 'Facebook',
        useIn: ['navigation-tabs'],
      },
      path: '/facebook',
    },
  ];
}
